export enum GuaranteeTC {
  Theft = '31',
  AxonTheft = '211'
}

export enum VatThresholdTC {
  Exc = '2',
  For = '3',
  Inc = '1',
}

export enum VatPercentageTC {
  Vat0 = '00000',
  Vat6 = '00600',
  Vat21 = '02100',
}

export enum RimItemTC {
  AAndO = 'A&O',
  AnderePlus = 'AnderePlus',
  CompOptieFranchise = 'CompOptieFranchise',
  CompOscars = 'CompOscars',
  Evenredigheid = 'Evenredigheid',
  Hoofdsom = 'Hoofdsom',
  Materiaal = 'Materiaal',
  OV = 'OV',
  RAndB = 'R&B',
  TerugvorderbareVrijstelling = 'TerugvorderbareVrijstelling',
  TO = 'TO',
  Voorschot = 'Voorschot',
  Vrijstelling = 'Vrijstelling',
  VrijstellingInhoudKelder = 'VrijstellingInhoudKelder',
  Werkuren = 'Werkuren'
}

export enum ReportTypeTC {
  Rim = 'RIM',
  Svs = 'SVS'
}

export enum CalculationUsageTC {
  Fin = 'CHFINSETTLINS',
  Diy = 'CHFINSETTLDIY',
  Rik = 'CHREPINKIND'
}

export enum RimSectionTC {
  Bu1 = 'Bu1',
  Bu2 = 'Bu2',
  Bu3 = 'Bu3',
  Co1 = 'Co1',
  Co2 = 'Co2',
  Co3 = 'Co3',
  Gen = 'Gen',
  Ob1 = 'Ob1',
  Ob2 = 'Ob2',
  Ob3 = 'Ob3'
}

export const ObjectDamages = [
  RimSectionTC.Ob1,
  RimSectionTC.Ob2,
  RimSectionTC.Ob3
];

export const BuildingDamages = [
  RimSectionTC.Bu1,
  RimSectionTC.Bu2,
  RimSectionTC.Bu3
];

export const ContentDamages = [
  RimSectionTC.Co1,
  RimSectionTC.Co2,
  RimSectionTC.Co3
];

export enum PolicySubTypeTC {
  BelfiusHome = 'BELFIUS HOME',
  DvvBrand = 'DVV BRAND'
}

export enum DamageTypeTC {
  Building = '46',
  Content = '47',
  Object = '24'
}

export enum ReportStatusTC {
  Temp = 'Temp',
  End = 'End',
  EndNoSVS = 'EndNoSVS',
  FreeText = 'FreeText',
  Unknown = 'Unknown'
}

export enum SettlementByIntermediaryTC {
  SeViIn = '1',
  NoSeIn = '2'
}
